import { render, staticRenderFns } from "./LastVisitFilter.vue?vue&type=template&id=336c2570&scoped=true&"
import script from "./LastVisitFilter.vue?vue&type=script&lang=js&"
export * from "./LastVisitFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336c2570",
  null
  
)

export default component.exports